import { ImmutableStore } from 'fluxible-immutable-utils';
import Actions from '../constants/Actions';

const defaultState = {
  authenticationFailed: false,
  formSubmitted: false,
  formLoading: false,
  authenticationAttempted: false
};

//Make a generic form store factory
class AuthenticationStore extends ImmutableStore {
  static storeName = 'AuthenticationStore';

  static handlers = {
    [Actions.AUTHENTICATION__FAILED]: 'handleAuthenticationFailed',
    [Actions.AUTHENTICATION__CHECK_COMPLETED]: 'handleAuthenticationCompleted',
    [Actions.AUTHENTICATION__COMPLETED]: 'handleAuthenticationCompleted',
    [Actions.AUTHENTICATION__REJECTED]: 'handleAuthenticationFailed',
    [Actions.AUTHENTICATION__FORM_STATE_CLEARED]: 'handleClearFormState',
    [Actions.AUTHENTICATION__PASSWORD_FORGOT_COMPLETED]: 'handlePasswordResetComplete',
    [Actions.AUTHENTICATION__PASSWORD_FORGOT_STARTED]: 'handlePasswordResetStarted'
  };

  constructor(dispatcher) {
    super(dispatcher);
    this.setState(defaultState);
  }

  didAuthenticationFail() {
    return this.get('authenticationFailed') || false;
  }

  formSubmitted() {
    return this.get('formSubmitted');
  }

  formLoading() {
    return this.get('formLoading');
  }

  handleAuthenticationFailed() {
    this.mergeState({authenticationFailed: true});
  }

  handleAuthenticationCompleted({ authenticated }) {
    if (authenticated) {
      this.setState({authenticationFailed: false, passwordResetSent: false});
    }
  }

  handlePasswordResetComplete() {
    this.mergeState({
      formSubmitted: true,
      formLoading: false
    });
  }

  handlePasswordResetStarted() {
    this.mergeState({
      formLoading: true
    });
  }

  handleClearFormState() {
    this.mergeState({
      authenticationAttempted: false,
      formSubmitted: false,
      formLoading: false,
      passwordResetSent: false
    });
  }
}

export default AuthenticationStore;



// WEBPACK FOOTER //
// ./src/stores/AuthenticationStore.js